import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import PaymentTable from '../../../components/Tables/PaymentTable';
import { API } from '../../../shared/api/Api';
import axios from 'axios';
import { showToast } from '../../../utils/utils';
import { selectUserInformations } from '../../../features/authSlice';
import { useLocation, useParams, Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

const DEBOUNCE_DELAY = 700;

const CoursePaymentPage = () => {
    const [reFetchData, setReFetchData] = useState(false);
    const [payments, setPayments] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [loader, setLoader] = useState(true);

    const user = useSelector(selectUserInformations);
    const params = useParams();
    const location = useLocation();

    const fetchPaymentsForCourse = useCallback(async () => {
        try {
            const { data } = await axios.get(`${API.Courses.app_courses_allPaymentsForCourse}/${params.id}`, {
                params: { page: currentPage, search: debouncedSearch },
                headers: { Authorization: `Bearer ${user.token}` },
            });

            if (data.status === 200 && data.errorCode === 0) {
                setPayments(data.data.items);
                setCurrentPage(data.data.current_page);
                setTotalPages(data.data.last_page);
            } else {
                showToast("Error", "Failed to fetch courses", "error");
            }
        } catch (error) {
            showToast(
                "Error",
                error.response?.data?.message || "An error occurred",
                "error"
            );
        }
    }, [currentPage, debouncedSearch, user.token, reFetchData]);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
            setCurrentPage(1); // Reset to the first page on search change
        }, DEBOUNCE_DELAY);

        return () => clearTimeout(handler);
    }, [search]);

    useEffect(() => {
        const fetchData = async () => {
            setLoader(true); // Show loader during fetching
            try {
                setPayments([]);
                await fetchPaymentsForCourse();
            } catch (error) {
                showToast(
                    "Error",
                    error || "An error occurred",
                    "error"
                );
            } finally {
                setLoader(false);
                setReFetchData(false)
            }
        };
        fetchData();
    }, [fetchPaymentsForCourse, reFetchData]);

    const courseName = location.state?.course?.title || "Course";

    return (
        <div className='min-h-screen p-2 sl:pt-0 sm:p-2 md:p-4 sl:p-6'>
            {/* Header with Back Navigation */}
            <div className="mb-4 flex items-center gap-4">
                <Link
                    to={`/dashboard/courses/${params.id}`}
                    className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-gray-700"
                >
                    <FiArrowLeft className="w-5 h-5" />
                </Link>
                <div>
                    <h1 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white">
                        Payments for {courseName}
                    </h1>
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                        View payment history and transactions
                    </p>
                </div>
            </div>

            <PaymentTable
                currentPage={currentPage}
                loader={loader}
                onPageChange={setCurrentPage}
                onSearchChange={setSearch}
                payments={payments}
                totalPages={totalPages}
                setReFetchData={setReFetchData}
                coursePayments={true}
                courseData={location.state}
            />
        </div>
    )
}

export default CoursePaymentPage
